import { Coordinate } from 'types/map';
import { MarkerType } from 'types/marker';

type DBExhibit = {
  id: string;
  name: string;
  description?: string;
  latlng: {
    x: number;
    y: number;
  };
  image_url?: string;
  markerIcon?: string;
};

function toLatLng(path): Coordinate {
  return [path.x, path.y];
}

export async function getMarkers(): Promise<MarkerType[]> {
  return fetch(`${process.env.SERVER_URL}/exhibits`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then((res) => res.json())
    .then((res: DBExhibit[]) => {
      return res.map((exhibit) => ({
        id: exhibit.id,
        title: exhibit.name,
        description: exhibit.description,
        latlng: toLatLng(exhibit.latlng),
        image: exhibit.image_url,
        markerIcon: exhibit.markerIcon,
      }));
    })
    .catch((err) => {
      console.log('Fetch exhibits error', err);
      return [];
    });
}

export async function addMarker(marker: MarkerType) {
  return fetch(`${process.env.SERVER_URL}/exhibits`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(marker),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.status && res.status !== 200) {
        throw 'Add marker failed';
      }
    })
    .catch((err) => {
      console.log('Add marker error', err);
      throw err;
    });
}

export async function changeMarker(marker: MarkerType) {
  const { id } = marker;
  return fetch(`${process.env.SERVER_URL}/exhibits/${id}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(marker),
  }).then((res) => {
    if (res.status !== 200) {
      throw 'Change marker failed';
    }
  });
}

export async function deleteMarker(id: string) {
  return fetch(`${process.env.SERVER_URL}/exhibits/${id}`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id }),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.status && res.status !== 200) {
        throw 'Delete marker failed';
      }
    })
    .catch((err) => {
      console.log('Delete marker error', err);
      throw err;
    });
}
